module.exports = __webpack_public_path__ + "media/images/img_top_mv-0f6bf5e50c2343224a6ad35a6dc2e9e3.jpg";